export const TOKEN_ID = 'basis-ui2';
export const TOKEN_EXPIRATION = 'token-expire-basis-ui2';
export const TOKEN_USER = 'user-basis-ui2';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
